import { Directive, HostListener, Input } from '@angular/core';
import { FormHelper } from 'src/app/core/helpers/form.helper';

@Directive({
  selector: '[appAllowedChars]',
})
export class AllowedCharsDirective {
  @Input({ required: true }) appAllowedChars: string = '';

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent): void {
    FormHelper.verificarCaracter(event, this.appAllowedChars);
  }
}
